<template>
  <div class="main-content" id="content">
    <h3 class="marginBottom20">
      {{
        `${type === "add" ? "新增" : type === "edit" ? "编辑" : "查看"}软件工具`
      }}
    </h3>
    <!-- <el-card style="padding-left: 50px"> -->
    <el-form
      ref="form"
      :model="form"
      label-position="left"
      label-width="120px"
      :rules="rules"
    >
      <el-form-item label="软件工具名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入"
          style="width: 400px"
          maxlength="50"
          :disabled="disabled"
        ></el-input>
      </el-form-item>
      <el-form-item label="软件工具分类" :span="8" prop="classifyId">
        <el-select
          v-model="form.classifyId"
          clearable
          style="width: 400px"
          :disabled="disabled"
        >
          <el-option
            v-for="item in classifyList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="行业概述" prop="softwareDesc">
        <el-input
          v-model="form.softwareDesc"
          placeholder="请输入"
          style="width: 400px"
          maxlength="500"
          :disabled="disabled"
          type="textarea"
          :rows="8"
          show-word-limit
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="主图" :span="8" prop="mainImage">
        <FormImgUpload
          :url="form.mainImage"
          @upload="uploadImg"
          :limit="1"
          :maxSize="2"
          :accept="$store.state.user.uploadView.imageUploadFormat"
          :multiple="true"
          :disabled="disabled"
        />
        <div style="color: #c0c1c3">
          建议尺寸：50px*50px，图片格式：{{
            $store.state.user.uploadView.imageUploadFormat
          }}
        </div>
      </el-form-item> -->
      <!-- <el-form-item label="类型" :span="8" prop="classifyId">
        <el-radio-group
          v-model="form.type"
          @change="getType"
          :disabled="disabled"
        >
          <el-radio
            v-for="item in OTypeInfo"
            :label="item.value"
            :key="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="压缩包" prop="downloadUrl">
        <FormFileUpload
          :url="form.downloadUrl"
          @upload="upload"
          :disabled="disabled"
          :limit="1"
          :maxSize="500"
          :accept="'.pdf,.zip,.rar'"
          :multiple="true"
          :isFileName="'上传成功'"
          :showView="false"
        />
        <div style="color: #c0c1c3">
          <!-- 软件工具等安包装请上传压缩包，文件格式：.zip,.rar， -->
          文件格式：.pdf,.zip,.rar，
        </div>
      </el-form-item>

      <el-form-item>
        <el-button @click="revert">返回</el-button>
        <el-button type="primary" @click="submit" v-if="!disabled"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
    <!-- </el-card> -->
  </div>
</template>

<script>
import {
  infoSoftwareClassify,
  infoSoftwareAdd,
  infoSoftwareUpdate,
  infoSoftwareView,
} from "@/api/info/software";
import FormEditor from "@/components/formComponents/formEditor";
import dayjs from "dayjs";
import FormFileUpload from "@/components/formComponents/formFileUpload";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { ETypeInfo, MTypeInfo, OTypeInfo } from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "create",
  components: {
    FormEditor,
    FormFileUpload,
    FormImgUpload,
  },
  data() {
    return {
      ETypeInfo: ETypeInfo,
      MTypeInfo: MTypeInfo,
      OTypeInfo: OTypeInfo,
      classifyList: [],
      id: this.$route.query.id,
      disabled: this.$route.query.type === "view",
      type: this.$route.query.type,
      form: {
        classifyId: "",
        softwareDesc: "",
        name: "",
        downloadUrl: [],
      },
      //校验规则
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        softwareDesc: [{ required: true, message: "请输入", trigger: "blur" }],
        classifyId: [{ required: true, message: "请输入", trigger: "blur" }],
        downloadUrl: [
          {
            required: true,
            message: "请上传",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error("请上传"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      loadingSubmit: false,
    };
  },
  mounted() {
    this.getClassifyList();
    if (this.id) {
      this.getView();
    }
  },
  methods: {
    async getView() {
      if (this.id) {
        const { data } = await infoSoftwareView(this.id);
        this.form = {
          ...data,
          downloadUrl: data.downloadUrl.split(","),
        };
      }
    },

    async submit() {
      if (this.loadingSubmit) {
        return;
      }
      let newVal = {
        ...this.form,
        downloadUrl: this.form.downloadUrl.join(","),
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingSubmit = true;
          if (this.type == "add") {
            infoSoftwareAdd({
              ...newVal,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                // this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          } else {
            infoSoftwareUpdate({
              ...newVal,
              id: this.id,
            })
              .then((res) => {
                // 获取数据成功后的其他操作
                if (res.code == 200) {
                  this.loadingSubmit = false;
                  this.$router.go(-1);
                } else {
                  this.loadingSubmit = false;
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                // loading.close();
                // this.$message.error(err.msg);
                this.loadingSubmit = false;
              });
          }
        }
      });
    },
    //富文本框变化替换值
    editoChange(e) {
      this.form.content = e;
    },
    //文件上传
    upload(e, name, size) {
      console.log(name, size, "name,sizename,sizename,size");

      if (Array.isArray(e)) {
        this.form.downloadUrl = [...e];
      } else {
        this.form.downloadUrl = [...this.form.downloadUrl, e];
      }
      this.form.urlName = name;
      this.form.urlSize = size ? size.toFixed(2) : "";
    },
    //图片上传
    uploadImg(e) {
      if (Array.isArray(e)) {
        this.form.mainImage = [...e];
      } else {
        this.form.mainImage = [...this.form.mainImage, e];
      }
    },
    //权益分类
    getClassifyList() {
      infoSoftwareClassify({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = res.data;
        }
      });
    },
    revert() {
      this.$router.go(-1);
    },
    // 切换类型
    getType(e) {
      if (e == 1) {
        this.form.content = "";
      } else {
        this.form.content = [];
      }
    },
  },
};
</script>

<style scoped>
.main-content {
  padding-left: 30px;
  padding-right: 40%;
}
</style>
